import HotelList from '@/views/HotelList/index.vue'

const HotelListRouter = {
  path: '/hotel-list',
  name: 'HotelList',
  component: HotelList,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default HotelListRouter
